import {Component, OnDestroy} from "@angular/core";
import {DxGridColumn} from "../../../domain/ui-options/column/dx-grid-column";
import {DxGridColumnDataType} from "../../../domain/ui-options/column/dx-grid-column-data-type";
import {DxGridRow} from "../../../domain/dx-grid-row";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";


@Component({selector: 'dx-base-cell-render', template: ''})
export class DxBaseCellRenderComponent implements ICellRendererAngularComp, OnDestroy {
  /**
   * Текущее отображаемое в ячейке значение.
   * @name value
   * @type {string}
   */
  public value: string;

  /**
   * Параметры рендера, предоставляемые AgGrig API.
   * @name _params
   * @type {any}
   */
  protected _params: any;

  /**
   * Прямая ссылка на метаданные колонки, передаваемые через параметры рендера.
   * @name _columnOptions
   * @type {DxGridColumn}
   */
  protected _columnOptions: DxGridColumn;

  /**
   * Опции типа данных для управления рендерингом.
   * @name _dataTypeOptions
   * @type {DxGridColumnDataType}
   */
  protected _dataTypeOptions: DxGridColumnDataType;

  /**
   * Данные строки в которой находится ячейка.
   * @name _row
   * @type {DxGridRow}
   */
  protected _row: DxGridRow;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this._init(params);
  }

  ngOnDestroy(): void {
    this._destroy();
  }


  public refresh(params: any): boolean {
    return this._refresh(params);
  }

  public transform(value: any): string {
    if(!value) return '';
    return value.toString();
  }


  protected _init(params: ICellRendererParams): void {
    this._params = params;
    this._row = <DxGridRow> this._params.data;
    this._columnOptions = this._params.columnOptions;
    this._dataTypeOptions = this._columnOptions.dataType;
  }

  protected _destroy(): void {

  }

  protected _refresh(params: any): boolean {
    return false;
  }
}
